import { ClientRequestContextBase } from "abweb/dto/generated/ds/ClientRequestContextBase";
import { HistoricalPointInTime } from "abweb/dto/ds/HistoricalPointInTime";
export class ClientRequestContext extends ClientRequestContextBase {
  static createClientRequestContext(contentRestrictions, fieldSpecs, filterSpecs, sortSpecs, runQuery) {
    if (contentRestrictions == null) {
      contentRestrictions = [];
    }
    if (fieldSpecs == null) {
      fieldSpecs = [];
    }
    if (filterSpecs == null) {
      filterSpecs = [];
    }
    if (sortSpecs == null) {
      sortSpecs = [];
    }
    if (runQuery == null) {
      runQuery = false;
    }
    const retVal = new ClientRequestContext();
    retVal.initClientRequestContext(HistoricalPointInTime.createEmptyHistoricalPointInTime(), contentRestrictions, fieldSpecs, filterSpecs, /*refreshExpression*/"", /*refreshInterval*/0, runQuery, sortSpecs);
    return retVal;
  }
  constructor() {
    super();
  }
}
//# sourceMappingURL=ClientRequestContext.js.map
